import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createItemCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/itemCardBlockHelper";
import {
  createButtonBlock,
  createH2Block,
  createH4Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getFontSizeOptions,
  getFontWeightOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import calendarImagePlaceholder from "../../CallToAction/CardCallToAction/calendar_image_placeholder_filled.png";
import chatImagePlaceholder from "../../CallToAction/CardCallToAction/chat_image_placeholder_filled.png";
import fileImagePlaceholder from "../../CallToAction/CardCallToAction/file_image_placeholder_filled.png";
import { getSalesBlockSecondaryStyleOptions } from "../constants";

const items = [
  {
    image: {
      signedId: "",
      placeholder: fileImagePlaceholder,
    },
    title: "Complete a Brief Application (5 Minutes)",
    description: "This helps me understand your goals and challenges.",
  },
  {
    image: {
      signedId: "",
      placeholder: calendarImagePlaceholder,
    },
    title: "Schedule Your Free 45-Minute Strategy Call",
    description: "We'll discuss your goals and determine if we're a good fit.",
  },
  {
    image: {
      signedId: "",
      placeholder: chatImagePlaceholder,
    },
    title: "Make a Decision That Serves Your Future",
    description:
      "If we're aligned, we'll get started on your transformation right away.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock12",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Your Transformation Begins with One Decision",
        }),
        createPBlock({
          text: "The difference between where you are now and where you want to be is the action you take today.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createH4Block({
          text: "Here’s What Happens When You Apply:",
          styles: {
            fontWeight: getFontWeightOptions("600"),
          },
        }),
        ...items.map(item => createItemCardBlock(item)),
      ],
    },
    button: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Apply Now (Free, No Obligation)",
          href: "#",
        }),
      ],
    },
    buttonDescription: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Limited to 5 new clients per month to ensure quality",
          paragraphStyle: "p3",
        }),
      ],
    },
    footer: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "“The best investment you can make is in yourself. The returns are exponential.”",
        }),
        createPBlock({
          text: "— Sarah Johnson, Founder of The Breakthrough Method™",
          styles: {
            fontWeight: getFontWeightOptions("600"),
            fontSize: getFontSizeOptions("22px"),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockSecondaryStyleOptions(),
      },
    },
  },
};
